import { useSelector } from 'react-redux'
import { propEq, reject } from 'ramda'
import type { WorkFlowTypesConstant } from '@pbt/pbt-ui-components'

import { getCurrentBusiness } from '~/store/reducers/auth'
import { getFilteredWorkFlowTypes } from '~/store/reducers/constants'

const useWorkflowTypes = (): WorkFlowTypesConstant[] => {
  const types = useSelector(getFilteredWorkFlowTypes)
  const business = useSelector(getCurrentBusiness)

  return business?.kioskEnabled
    ? types
    : reject(propEq('shortName', 'Kiosk'), types)
}

export default useWorkflowTypes
